import { EmployeeEntity } from "./types/entities.ts";
import { LdapName } from "./types/primitives.ts";

export const unknownEmployee = (
  uidNumber: number,
): EmployeeEntity & { uid: LdapName } => ({
  uidNumber,
  name: `UID${uidNumber}`,
  uid: `UID${uidNumber}`,
  email: null,
  groups: [],
  tngSubcompany: null,
  givenName: null,
  surname: null,
  preferredLanguage: null,
});
